import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { useQuery, useApolloClient } from "react-apollo";
import { Fieldset } from "rbx";

import {
  ALL_USER_GROUP_MEMBERSHIPS_QUERY,
  CREATE_USER_GROUP_MEMBERSHIP_MUTATION,
  DELETE_USER_GROUP_MEMBERSHIP_MUTATION
} from "../../graphql/UserGroupMemberships/UserGroupMemberships.graphql";
import { ourToast as toast } from "../../utils";

import UserGroupMembershipForm from "./UserGroupMembershipForm";

const EditUserGroupMembershipForm = ({ id, readOnly }) => {
  const client = useApolloClient();
  const [inputs, setInputs] = useState({});

  // fetch all user group memberships matching current user id
  const { data } = useQuery(ALL_USER_GROUP_MEMBERSHIPS_QUERY, {
    variables: { where: { UserRecIdRef: parseInt(id) } }
  });

  useEffect(() => {
    const withUserGroupMemberships = data?.UserGroupMemberships.reduce(
      (acc, curr) => ({ ...acc, [curr.GroupRecIdRef]: true }),
      {}
    );
    setInputs({ ...withUserGroupMemberships });
  }, [data]);

  const refetchQueries = ["ALL_USER_GROUP_MEMBERSHIPS_QUERY"];

  const handleChange = async (e, group) => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
    try {
      if (value) {
        await client.mutate({
          mutation: CREATE_USER_GROUP_MEMBERSHIP_MUTATION,
          variables: {
            data: {
              UserRecIdRef: parseInt(id),
              GroupRecIdRef: parseInt(group.RecId)
            }
          },
          refetchQueries
        });
        toast.success("User Group Membership updated successfully.");
      } else {
        const ugm = data?.UserGroupMemberships?.find(
          mem =>
            mem.UserRecIdRef === parseInt(id) &&
            mem.GroupRecIdRef === parseInt(group.RecId)
        );

        if (!ugm) {
          toast.error("Error updating User Group Membership.");
        }

        await client.mutate({
          mutation: DELETE_USER_GROUP_MEMBERSHIP_MUTATION,
          variables: {
            where: {
              RecId: parseInt(ugm.RecId)
            }
          },
          refetchQueries
        });
        toast.success("User Group Membership updated successfully.");
      }
    } catch (err) {
      toast.error("Error updating User Group Membership.");
    }
  };
  return (
    <React.Fragment>
      <Fieldset>
        <UserGroupMembershipForm
          inputs={inputs}
          readOnly={readOnly}
          onChange={handleChange}
        />
      </Fieldset>
    </React.Fragment>
  );
};

EditUserGroupMembershipForm.propTypes = {
  id: PropTypes.number,
  readOnly: PropTypes.bool
};
export default EditUserGroupMembershipForm;
